import { useSelector } from 'react-redux';

const NOTIFICATION_SUCCESS = 'RCM-STATUS-DONE';

export const useNotificationScript = () => {
  const userInfo = useSelector((state) => state.userInfo);

  return (userInfo && !userInfo.guest) ? `var url_param_token = "${userInfo?.idToken}";
  var connection = new signalR.HubConnectionBuilder().withUrl("${process.env.REACT_APP_NOTIFICATION_SCRIPT}", { accessTokenFactory: () => url_param_token }).build();
  connection.on("ReceiveMessage", function (event, message) {
      console.log("NotificationEvent: " + event);
      if(message === "${NOTIFICATION_SUCCESS}") {
       window.location.href = "${process.env.REACT_APP_THANK_YOU_REDIRECT}";
     }
  });
  connection.start().then(function () {
      //wharever you need
  }).catch(function (err) {
      return console.error(err.toString());
  });` : null;
};
